import { useDisclosure } from '@chakra-ui/react';
import { IQuoteOfferingReqSchema } from '@monetize/types/app';
import { UseFormSetValue } from 'react-hook-form';

export const useManageProduct = ({
  setValue,
}: {
  setValue: UseFormSetValue<IQuoteOfferingReqSchema>;
}) => {
  const {
    open: isManageProductModalOpen,
    onOpen: onManageProductModalOpen,
    onClose: onManageProductModalClose,
  } = useDisclosure();
  const {
    open: isDrawerOpen,
    onOpen: onDrawerOpen,
    onClose: onDrawerClose,
  } = useDisclosure();

  // Clearing the offering id also clears the derived offering in QuoteOffering
  const handleOnModalClose = () => {
    onManageProductModalClose();
    setValue('offeringId', '');
  };

  return {
    handleOnModalClose,
    isManageProductModalOpen,
    onManageProductModalOpen,
    onManageProductModalClose,
    //drawer
    isDrawerOpen,
    onDrawerOpen,
    onDrawerClose,
  };
};
